export default "__VITE_ASSET__CzIBjyPw__"